export default "__VITE_ASSET__BlTXB7yZ__"